let currentMenuItem;

const CountrySelector = {
	
	registerEvents: () => { 
		document.addEventListener( 'click', CountrySelector.closeOpenSubmenu );
	},
	
	menuAccordion: () => {
		let accordionHeading = document.querySelector('#country-selector');
		
		accordionHeading.addEventListener('click', (e) => {
			e.preventDefault();
			CountrySelector.toggleSubmenu(accordionHeading);
		});
		accordionHeading.addEventListener('keypress', (e) => {
			CountrySelector.toggleSubmenu(accordionHeading);
		});
		
	},
	
	toggleSubmenu: (item) => {
		let subMenu = item.nextElementSibling;
		
		item.classList.contains('active') ? item.classList.remove('active') : item.classList.add('active');
		
		if (subMenu.classList.contains('active')) {
			subMenu.classList.remove('active')
			subMenu.setAttribute("aria-expanded", false);
			subMenu.setAttribute("aria-hidden", true);
			
		} else {
			subMenu.classList.add('active');
			subMenu.setAttribute("aria-expanded", true);
			subMenu.setAttribute("aria-hidden", false);
		}
		
		if ( currentMenuItem && item !== currentMenuItem ) {
			CountrySelector.toggleSubmenu( currentMenuItem );
		}
		
		if (item.classList.contains('active')) {
			currentMenuItem = item;
		} else {
			currentMenuItem = false;
		}
		
		if (subMenu.style.maxHeight) {
			subMenu.style.maxHeight = null;
		} else {
			subMenu.style.maxHeight = subMenu.scrollHeight + "px";
		}
		
	},
	
	closeOpenSubmenu: (e) => {
		if ( currentMenuItem && ! e.target.closest( '.sub-menu.active') && ! e.target.closest( '#country-selector') ) {
			CountrySelector.toggleSubmenu( currentMenuItem );
		}
	},
	
	init: () => {
		CountrySelector.registerEvents();
		CountrySelector.menuAccordion();
		
		document.addEventListener('keyup', event => {
			if (event.keyCode === 27) {
				// we're in a submenu item
				if( null !== event.target.closest('ul[aria-hidden="false"]') ) {
					currentMenuItem.focus();
					CountrySelector.toggleSubmenu( currentMenuItem );
				}
				
				
			}
		});
		
	}
}

export default CountrySelector;